import { render, staticRenderFns } from "./whatnow.vue?vue&type=template&id=042aa78c"
import script from "./whatnow.vue?vue&type=script&lang=js"
export * from "./whatnow.vue?vue&type=script&lang=js"
import style0 from "./whatnow.vue?vue&type=style&index=0&id=042aa78c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports